import { AddIconButton } from '@library/components/buttons/AddIconButton';
import { PageTitle } from '@library/components/PageTitle';
import { UserRoles } from '@bo-components/userRoles/UserRoles';
import { UserRolesContext } from '@bo-hooks/user/useAdminUsersContext';
import { UserRolesFilters } from '@bo-components/userRoles/UserRolesFilters';
import { UserRolesModals } from '@bo-components/userRoles/UserRolesModals';
import { useAdminUsers } from '@bo-hooks/user/useAdminUsers';
import { useSentrySetDashBoardTag } from '@bo-hooks/sentry/useSentrySetDashBoardTag';
import { withProfiler } from '@sentry/react';

export const UserRolesDashboardView = () => {
  useSentrySetDashBoardTag({ dashboardName: 'UserRoles' });

  const { userRolesContext } = useAdminUsers();
  const { modals } = userRolesContext;

  const handleCreateUser = () => {
    modals.onCreateModalOpen(true);
  };

  return (
    <div className="flex w-auto flex-col gap-4 px-6 pb-2 pt-3">
      <div className="flex justify-between">
        <PageTitle title="Admin Users" />
        <AddIconButton
          className="bg-stankonia-100 hover:bg-stankonia-100 text-soClean-100 !size-auto px-2 py-1"
          label="Create user"
          onClick={handleCreateUser}
        />
      </div>
      <UserRolesContext.Provider value={userRolesContext}>
        <UserRolesFilters />
        <UserRoles />
        <UserRolesModals />
      </UserRolesContext.Provider>
    </div>
  );
};

export const UserRolesDashboard = withProfiler(UserRolesDashboardView);
